export default {
  type: "image",
  data: {
    paddingLeft: 0,
    paddingRight: 0,
    paddingTop: 0,
    paddingBottom: 0,
    autoWidth: true,
    width: 100,
    alt: "Ri+",
    linkUrlType: "web",
    linkUrl: "",
    linkNewTab: false,
    align: "center",
    url: "",
  },
  children: [],
};
